export const AdderGeneric = ({ text ='', onAdd=f=>f}) => {


    return (
        <div className="adder-generic" style={{
                backgroundColor:"black", 
                position:"relative",
                borderRadius:"4px", 
                width:"fit-content", 
                height:"32px", 
                color:"white",
                cursor:"pointer",
                display:"flex", 
                alignItems:"center",
                gap:"8px"}} onClick={onAdd}>
            {text.length ? (<span className="text">{text}</span>) : null} 
            <svg width="32" height="32" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style={{ObjectFit: "contain", maxWidth:"100%", maxHeight:"100%"}}>
                <path id="y-axis" d="M50 20 V80" stroke="white" stroke-width="10" stroke-linecap="round"/>
                <path id="x-axis" d="M20 50 H80" stroke="white" stroke-width="10" stroke-linecap="round"/>
            </svg>
        </div>
    );
};